import React from 'react'
import PropTypes from 'prop-types'
import ButtonSetting from '../ButtonSetting'

const ForgetAll = (props) => {
    const settings = {
        label: props.label,
        title: props.title,
        onClick: () => {
            // eslint-disable-next-line
            if (confirm(props.confirmMessage)) {
                props.forgetAll()
                props.showMessage()
            }
        },
    }

    return <ButtonSetting {...settings} />
}

ForgetAll.propTypes = {
    label: PropTypes.string,
    title: PropTypes.string,
    confirmMessage: PropTypes.string,
    forgetAll: PropTypes.func,
    showMessage: PropTypes.func,
}

export default ForgetAll



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/ForgetAll/component.js